import type { FieldWidth } from '@platform/core/types';

/** Скільки колонок із чотирьох займає поле в перегляді форми (прототип v4 fpGroups): S — 1, M — 2, L — увесь рядок. */
export const previewSpan = (width: FieldWidth): string => (width === 'L' ? '1 / -1' : width === 'M' ? 'span 2' : 'span 1');
